import React, { FC } from 'react';

import { GridList } from '~/components/unified/GridList';

import { LogInfo } from './LogInfo';
import { LogStatusCode } from './LogStatusCode';
import { LogTimeStamp } from './LogTimeStamp';
import { LogListItem } from './types';

type LogsListProps = {
  logs: LogListItem[];
  onClick: (log: LogListItem) => void;
};

export const LogsList: FC<LogsListProps> = ({ logs, onClick }) => {
  return (
    <GridList
      className="px-8 py-4 grid"
      gridTemplateColumns="repeat(auto-fit, minmax(14rem, 1fr))"
    >
      <GridList.Header className="px-3 mb-4">
        <span>Type</span>
        <span>Request</span>
        <span>Status</span>
        <span>Timestamp</span>
      </GridList.Header>
      {logs.map((log, index) => (
        <GridList.Item
          className="px-3 py-4 cursor-pointer hover:bg-gray-50"
          key={`${log.requestPath}-${log.timestamp}-${index}`}
          onClick={() => onClick(log)}
        >
          <span className="capitalize">{log.type}</span>
          <LogInfo
            requestMethod={log.requestMethod}
            requestPath={log.requestPath}
          />
          <div>
            <LogStatusCode responseStatus={log.responseStatus} />
          </div>
          <div>
            <LogTimeStamp timestamp={log.timestamp} />
          </div>
        </GridList.Item>
      ))}
    </GridList>
  );
};
